module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Medium-Alphabetic.a8f49965.woff";